import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  saveBrand: ['brand', 'onSuccess', 'onError'],
  removeBrand: ['brand', 'onSuccess', 'onError'],
  brandError: ['error']
})

const saveBrand = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeBrand = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const brandError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.BRAND_ERROR]: brandError,

  [Types.SAVE_BRAND]: saveBrand,
  [Types.REMOVE_BRAND]: removeBrand,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as BrandTypes,
  Creators as BrandActions
}
